/** User message that kicks off the Goal Quality Coach evaluation (popup CTA and chat chip). */
export const GOAL_COACH_START_QUERY = "Help me improve this goal.";

/** User message that kicks off the Form Building Coach evaluation (chat chip). */
export const FORM_BUILDING_COACH_START_QUERY = "Help me improve this form";

export const COMPETENCY_IMPORT_INTRO =
	"Setting up competencies? Upload a document and I'll pull them out for you — or just tell me about the role and we'll build them together.";
